/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {finishTutorial} from '../api'

export const useMutationFinishTutorial = createReactQueryMutationHook('finishTutorial', finishTutorial)
